import CTAButton from '@/components/common/CTAButton';
import { useLanguage } from '@/contexts/LanguageContext';

const CTASection = () => {
  const { t } = useLanguage();

  return (
    <div className="bg-gradient-gold rounded-xl p-8 md:p-12 text-center shadow-elevation-lg">
      <h2 className="font-heading text-2xl md:text-3xl font-bold text-primary mb-4">
        {t('whyGoldSilver.cta.title')}
      </h2>
      <p className="font-body text-lg text-primary-foreground/90 mb-8 max-w-2xl mx-auto">
        {t('whyGoldSilver.cta.description')}
      </p>
      <CTAButton href="/contact" variant="secondary">
        {t('whyGoldSilver.cta.button')}
      </CTAButton>
    </div>
  );
};

export default CTASection;